import React from "react";
import { type DetailedPaymentPrefUnionObjectType } from "../../common/types";
import { BasePaymentPrefDisplay } from "../BasePaymentPrefDisplay";
import { PaymentPrefDetails } from "../PaymentPrefDetails";
import { isRevealablePaymentPref } from "./utils";

export type PreviewPaymentPrefDisplayProps = {
  paymentPref: DetailedPaymentPrefUnionObjectType;
};

export const PreviewPaymentPrefDisplay: React.FC<PreviewPaymentPrefDisplayProps> = ({
  paymentPref,
}: PreviewPaymentPrefDisplayProps) => {
  return (
    <BasePaymentPrefDisplay
      paymentPref={paymentPref}
      displayRevealDetails={isRevealablePaymentPref(paymentPref)}
      renderDetails={() => <PaymentPrefDetails paymentPrefFull={paymentPref} />}
    />
  );
};
